export function formatHebrewItemCount(count: number): string {
  return count === 1 ? "פריט אחד" : `${count} פריטים`;
}
